import {Injectable} from '@angular/core';
import {Customer} from './customer.model';
import {CrudService} from '@ngx-ivengi/crud';

@Injectable()
export class CustomerService extends CrudService<Customer> {
  public entityType = Customer;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/customer/customer.service.ts